import React, { Component } from 'react';
import { Text, View, Image } from 'react-native';

import { styles } from '../../constants/styles';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { resetState, updateMedicalTeamParticipants } from './actions';

import { getEditingCaseParticipantsExcludingPatient } from '../cases/selector';

import {
  OPScreenComponent,
  Container,
  FormInput,
  IconButton,
  NavBar,
  I18n,
  Utils,
  Navigation,
  FormHelpers,
  Select,
} from '../components';

const providerTypeInput = React.createRef();
const providerNameInput = React.createRef();

class MedicalTeamForm extends OPScreenComponent {
  static navigatorStyle = NavBar && NavBar.navigatorStyle;

  constructor(props) {
    super(props);

    this._instanceButtons = {
      rightButtons: this.props.editable ? [NavBar.buttons.save] : [],
      leftButtons: [NavBar.buttons.cancel],
    };

    this.state = {
      providerType: null,
      providerName: null,
    };
  }

  componentDidMount() {
    Utils.trackScreen('MedicalTeam', 'FormParticipants');
    super.componentDidMount();
  }

  componentWillUnmount() {
    this.props.actions.resetState();
    super.componentWillUnmount();
  }

  componentDidUpdate(prevProps) {
    if (this.props.status === 'success' && prevProps !== 'success') {
      Navigation.close(this.props);
      return;
    }
  }

  onSave = () => {
    Utils.trackEvent('Action', 'Tap', 'Submit MedicalTeam Participant');

    const fieldsToValidate = [providerTypeInput.current, providerNameInput.current];
    const formIsValid = FormHelpers.validateFields(fieldsToValidate);
    if (!formIsValid) {
      return;
    }

    let obj = {
      userId: this.state.provider.id,
      isMedicalTeam: true,
    };

    this.props.actions.updateMedicalTeamParticipants(this.props.editingCaseId, obj);
  };

  _handleChangeProviderType = (providerType) => {
    this.setState({ providerType });
  };

  _handleChangeProviderName = (provider) => {
    const participant = this.props.participants.filter((p) => p.profile.userId == provider.id)[0];
    const providerTypeName = participant.profile.roleTitle;
    const providerType = { label: providerTypeName, id: providerTypeName };
    this.setState({ provider, providerType });
  };

  _formatNameOptions(arry) {
    return arry.map((p) => ({ label: p.profile.fullName, id: p.profile.userId }));
  }
  _providerNameOptions = () => {
    if (this.state.providerType) {
      return this._formatNameOptions(
        this.props.participants.filter((p) => {
          return p.profile?.roleTitle === this.state.providerType.id;
        })
      );
    } else {
      return this._formatNameOptions(this.props.participants.filter((p) => !!p.profile));
    }
  };
  _providerTypeOptions = () => {
    return this.props.providerTypes.map((id) => ({ label: id, id }));
  };

  render() {
    const providerTypeOptions = this._providerTypeOptions();
    return (
      <Container
        keyboardAvoidingScrollView={true}
        errorMessage={this.props.errorMessage?.message}
        renderActivityOverlay={this.props.status === 'requesting'}
      >
        <View style={styles.inputsContainer}>
          <Select
            ref={providerTypeInput}
            required={true}
            editable={this.props.editable}
            closeOnSelect={true}
            options={providerTypeOptions}
            label={I18n.t('medicalTeam.providerType')}
            value={this.state.providerType}
            onValue={this._handleChangeProviderType}
            webMode={true}
          />

          <Select
            ref={providerNameInput}
            required={true}
            editable={this.props.editable}
            closeOnSelect={true}
            options={this._providerNameOptions()}
            label={I18n.t('medicalTeam.providerName')}
            value={this.state.provider}
            onValue={this._handleChangeProviderName}
            webMode={true}
          />
        </View>
      </Container>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const participants = getEditingCaseParticipantsExcludingPatient(state);
  const participantsRoles = participants.map((p) => p.profile?.roleTitle).filter((r) => r != null);
  const providerTypes = [...new Set(participantsRoles)];
  return {
    status: state.screens.medicalTeam.status,
    errorMessage: state.screens.medicalTeam.errorMessage,
    editingCaseId: state.screens.cases.caseInfoCaseId,
    participants,
    providerTypes,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        updateMedicalTeamParticipants,
        resetState,
      },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MedicalTeamForm);
